(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabs-options"] && !Shopify.designMode) return;
  try {
    
console.log('{{ page_title }}')

  } catch(e) { console.error(e); }
})();
})();
